<script setup lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
import type { ICategory } from '@/components/content-app/interface/blog/IBlogCategory'

const isDark = false
const props = defineProps({
  categories: {
    type: Object as PropType<ICategory[]>,
    required: true
  }
})

const getRandomItems = computed(() => {
  let shuffledItems = [...props.categories]

  for (let i = shuffledItems.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffledItems[i], shuffledItems[j]] = [shuffledItems[j], shuffledItems[i]]
  }

  shuffledItems = shuffledItems.filter(
    (item: ICategory) => item.attributes.title !== 'Product Updates'
  )

  return shuffledItems.slice(0, 3)
})
</script>
<template>
  <section class="my-12 px-5 md:my-24 md:px-11 xl:my-28 xl:px-44">
    <h3 class="text-center text-[32px] font-medium md:whitespace-pre">
      Dive Deeper into More Topics
    </h3>
    <p class="mt-3 text-center font-light md:text-lg xl:mt-2">
      Get ready to go beyond the surface and explore a treasure trove of <br />
      diverse topics!
    </p>
    <div class="mt-12 grid grid-cols-1 gap-y-6 md:grid-cols-3 md:gap-x-7 xl:mt-10">
      <div
        v-for="item in getRandomItems"
        :key="item.attributes.url"
        class="flex h-64 items-end rounded-lg bg-contain bg-center bg-no-repeat"
        :style="{
          backgroundImage: `url(${
            !isDark
              ? item.attributes.thumbnail.data?.attributes.url
              : item.attributes.darkThumbnail.data?.attributes.url
          })`
        }"
      >
        <router-link
          :to="{ path: `/blog/category/${item.attributes.url}` }"
          target="_blank"
          class="-mb-0.5 flex w-full items-center justify-center rounded-b-lg bg-[#0A2540] py-4 text-white dark:bg-[#292929]"
        >
          {{ item.attributes.title }}
          <FontAwesomeIcon icon="fa-arrow-right" class="ml-1.5 text-lg text-white" />
        </router-link>
      </div>
    </div>
  </section>
</template>
